import React, { type FC, useEffect } from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { LoadableLazy } from '@confluence/loadable';

type ApprovalRequiredBeforePublishModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

const ApprovalRequiredBeforePublishModalContent = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalRequiredBeforePublishModal" */ './ApprovalRequiredBeforePublishModal.tsx'
			)
		).ApprovalRequiredBeforePublishModal,
});

export const ApprovalRequiredBeforePublishModal: FC<ApprovalRequiredBeforePublishModalProps> = ({
	isOpen,
	onClose,
}) => {
	useEffect(() => {
		void ApprovalRequiredBeforePublishModalContent.preload();
	}, []);

	return (
		<ModalTransition>
			{isOpen ? <ApprovalRequiredBeforePublishModalContent onClose={onClose} /> : null}
		</ModalTransition>
	);
};
